import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parameter-management-stock-criteria-organism',
  templateUrl: './parameter-management-stock-criteria-organism.component.html',
  styleUrls: ['./parameter-management-stock-criteria-organism.component.css']
})
export class ParameterManagementStockCriteriaOrganismComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
